// Google Analytics / Google Ads Conversion Tracking
export const trackGoogleConversion = (conversionLabel?: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    // Track Google Ads conversion with the specific conversion ID
    (window as any).gtag('event', 'conversion', {
      send_to: conversionLabel || 'AW-17809328061/EVczCKH2kuIbEL2Pk6xC',
      value: 1.0,
      currency: 'AED'
    });

    // Also track as a standard GA4 event
    (window as any).gtag('event', 'generate_lead', {
      event_category: 'engagement',
      event_label: 'form_submission',
    });

    console.log('Google conversion tracked');
  } else {
    console.warn('Google Analytics not loaded');
  }
};

// Meta Pixel Conversion Tracking
export const trackMetaConversion = (eventName: string = 'Lead') => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    (window as any).fbq('track', eventName, {
      content_name: 'Lead Form Submission',
      content_category: 'Real Estate Lead',
      value: 1.0,
      currency: 'AED',
    });

    console.log('Meta Pixel conversion tracked');
  } else {
    console.warn('Meta Pixel not loaded');
  }
};

// Track enhanced conversion with user data
export const trackEnhancedConversion = (email: string, phone: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('set', 'user_data', {
      email: email,
      phone_number: phone
    });
    console.log('Enhanced conversion data set');
  }
};

// Track both conversions
export const trackFormConversion = (formSource: string, email?: string, phone?: string) => {
  // Set enhanced conversion data if provided
  if (email && phone) {
    trackEnhancedConversion(email, phone);
  }
  
  trackGoogleConversion();
  trackMetaConversion('Lead');
  
  console.log(`Form conversion tracked for: ${formSource}`);
};

// UTM ID to Campaign Name Mapping
const utmCampaignMapping: { [key: string]: string } = {
  '0007': 'Gate Eleven | 0007 | UAE | EN | Google | 12/01/2026',
  // Add more UTM ID mappings as needed
};

// Get campaign name from UTM ID
export const getCampaignName = (utmId: string): string => {
  return utmCampaignMapping[utmId] || 'Direct/Organic';
};

// Extract UTM parameters from URL
export const getUTMParameters = () => {
  if (typeof window === 'undefined') {
    return { utm_id: '', utm_source: '', campaign_name: '' };
  }

  const urlParams = new URLSearchParams(window.location.search);
  const utmId = urlParams.get('utm_id') || '';
  const utmSource = urlParams.get('utm_source') || '';
  const campaignName = getCampaignName(utmId);

  return {
    utm_id: utmId,
    utm_source: utmSource,
    campaign_name: campaignName,
  };
};
